import { render } from "./TemplateManagement.vue?vue&type=template&id=0c5a6fcc&scoped=true"
import script from "./TemplateManagement.vue?vue&type=script&lang=js"
export * from "./TemplateManagement.vue?vue&type=script&lang=js"

import "./TemplateManagement.vue?vue&type=style&index=0&id=0c5a6fcc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5a6fcc"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QBtn,QIcon,QForm,QInput,QDialog,QSpinnerGears,QLinearProgress,QSelect});
